// Offline mode storage + local-connector client. No imports from api.js (api.js imports this for its fallbacks).
const DB = "xpattern-offline", STORE = "kv", KEY = "bundle", JOBS = "jobs";
export const LOCAL_URL = "http://127.0.0.1:47391";
export const OFFLINE_FLAG = "xpattern.offline"; // "1" when the signed-in user has offline mode → service worker registered

const open = () => new Promise((res, rej) => {
  const r = indexedDB.open(DB, 1);
  r.onupgradeneeded = () => r.result.createObjectStore(STORE);
  r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error);
});
const tx = async (mode, fn) => { const db = await open(); return new Promise((res, rej) => { const t = db.transaction(STORE, mode); const rq = fn(t.objectStore(STORE)); t.oncomplete = () => res(rq?.result); t.onerror = () => rej(t.error); }); };
export const idbGet = (k) => tx("readonly", (s) => s.get(k)).catch(() => undefined);
export const idbSet = (k, v) => tx("readwrite", (s) => s.put(v, k)).catch(() => undefined);
export const idbDel = (k) => tx("readwrite", (s) => s.delete(k)).catch(() => undefined);

let cached = null, loaded = false;
export const isNetError = (e) => Boolean(e) && !e.response && (e.code === "ERR_NETWORK" || /network|timeout|fetch/i.test(e.message || "") || e.request);
export const offlineEnabled = (user) => Boolean(user?.offline?.enabled);

export const loadBundle = async () => { if (!loaded) { cached = (await idbGet(KEY)) || null; loaded = true; } return cached; };
export const saveBundle = async (b) => { cached = b; loaded = true; await idbSet(KEY, b); window.dispatchEvent(new Event("xpattern:offline-synced")); };
export const clearBundle = async () => { cached = null; loaded = true; await idbDel(KEY); await idbDel(JOBS); };
export const bundleUsable = (b) => Boolean(b?.synced_at) && Date.now() - new Date(b.synced_at).getTime() < (b.days || 7) * 86400000;
export const bundleExpiresAt = (b) => (b?.synced_at ? new Date(new Date(b.synced_at).getTime() + (b.days || 7) * 86400000) : null);
// Synchronous view for hot paths (api fallbacks); loadBundle() must have run once (App does this at start).
export const bundleNow = () => (cached && bundleUsable(cached) ? cached : null);

let lastNetError = 0;
export const noteNetError = () => { lastNetError = Date.now(); };
export const noteNetOk = () => { lastNetError = 0; };
// "Offline" = the browser says so, or the server just failed to answer at all (dead Wi-Fi that still looks connected).
export const isOffline = () => (typeof navigator !== "undefined" && navigator.onLine === false) || Date.now() - lastNetError < 20000;

export const bundlePattern = (b, patternId) => { for (const v of b?.vehicles || []) { const p = v.patterns.find((x) => x.id === patternId); if (p) return p; } return null; };

// ---- local connector (Xpattern Software on this PC, v3.7+) ----
const withTimeout = (ms) => { const c = new AbortController(); setTimeout(() => c.abort(), ms); return c.signal; };
// targetAddressSpace: "loopback" = Chrome/Edge Local Network Access — lets the HTTPS app talk to the connector on 127.0.0.1
// (the browser asks the shop once: "allow this site to access devices on your local network").
const LOCAL_OPTS = { targetAddressSpace: "loopback" };
export const localStatus = () => fetch(`${LOCAL_URL}/status`, { ...LOCAL_OPTS, signal: withTimeout(4000) }).then((r) => r.json()).catch(() => null);
export const localCut = async (target, commands) => {
  const r = await fetch(`${LOCAL_URL}/cut`, { ...LOCAL_OPTS, method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ target, commands }), signal: withTimeout(180000) })
    .catch(() => { throw new Error("Xpattern Software is not running on this computer (or is older than v3.7). Start it from the Start menu and try again."); });
  const d = await r.json().catch(() => ({}));
  if (!r.ok || !d.ok) throw new Error(d.error || "The connector could not send the cut");
  return d;
};

// ---- cuts made offline: kept until the laptop is back online, then reported for job history / Fleet ----
export const queueOfflineJob = async (job) => { const q = (await idbGet(JOBS)) || []; q.push(job); await idbSet(JOBS, q.slice(-200)); };
export const takeOfflineJobs = async () => { const q = (await idbGet(JOBS)) || []; return q; };
export const clearOfflineJobs = () => idbDel(JOBS);
